import { render, staticRenderFns } from "./foodrecipescomment.vue?vue&type=template&id=7bfc0bfe&"
import script from "./foodrecipescomment.vue?vue&type=script&lang=js&"
export * from "./foodrecipescomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports